import { fadeInit, fadeAnim } from './fade';

function animatePicture(el) {
  return fadeAnim(el);
}

export function pictureInit(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;

  return fadeInit(elToTween, 100);
}

export function pictureAnim(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;

  const img = elToTween.querySelector('.picture__img');
  const { src } = img.dataset;

  img.decoding = 'sync';
  img.src = src;
  img.removeAttribute('data-src');

  let promise;

  if (typeof img.decode !== 'undefined') {
    promise = img.decode();
  } else {
    promise = new Promise((resolve, reject) => {
      const image = new Image();
      image.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');

      const errorHandler = () => {
        reject(new Error(`Failed to load image's URL: ${src}`));
      };

      const imageHandler = () => {
        image.removeEventListener('load', imageHandler);
        image.removeEventListener('error', errorHandler);
        img.src = image.src;
        image.remove();

        resolve();
      };

      image.addEventListener('load', imageHandler());
      image.addEventListener('error', errorHandler());
    });
  }

  return promise.then(() => animatePicture(elToTween));
}
